document.addEventListener('DOMContentLoaded', () => {
    const flickityControllers = [];

    function initFlickityIfMobile() {
        const sliders = document.querySelectorAll('.collection-list__products');

        sliders.forEach((slider, index) => {

            if (flickityControllers[index]) return;

            if (window.innerWidth < 768) {
                const flkty = new Flickity(slider, {
                    wrapAround: false,
                    prevNextButtons: true,
                    pageDots: false
                });

                flickityControllers[index] = flkty;
            }
        });
    }

    function destroyFlickityIfNotMobile() {
        flickityControllers.forEach((flkty, index) => {
            if (flkty && window.innerWidth >= 768) {
                flkty.destroy();
                flickityControllers[index] = null;
            }
        });
    }

    function handleResize() {
        destroyFlickityIfNotMobile();
        initFlickityIfMobile();
    }
    handleResize();

    window.addEventListener('resize', () => {
        clearTimeout(window._flickityResizeTimeout);
        window._flickityResizeTimeout = setTimeout(handleResize, 200);
    });
});